export default "__VITE_ASSET__DHK53Zbo__"